import React from 'react';
import { IIconProps } from '../interfaces';

const AleaFeature04Icon: React.FC<IIconProps> = ({
  color = '#2B4956',
  size = '41',
  active = false,
}) => (
  <svg
    width={size}
    height={Math.floor((Number(size) / 41) * 31)}
    viewBox="0 0 40 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Frame 64" opacity={active ? '1' : '0.5'}>
      <g id="Fall Prevention">
        <g id="Active">
          <path
            d="M0.873047 29.29H27.6739"
            stroke={active ? color : '#C6C6C6'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.1478 1.57031V8.05701L9.84473 17.8656V24.6408"
            stroke={active ? color : '#C6C6C6'}
            strokeWidth="2.85632"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.0531 6.06055C9.40307 6.06055 8.06543 7.39819 8.06543 9.04826C8.06543 10.6983 9.40307 12.036 11.0531 12.036C12.7032 12.036 14.0408 10.6983 14.0408 9.04826C14.0408 7.39819 12.7032 6.06055 11.0531 6.06055Z"
            fill={active ? color : '#C6C6C6'}
          />
          <path
            d="M24.4014 21.6565C24.4105 21.6474 24.4188 21.6378 24.4265 21.6278L24.421 21.1604C24.6726 20.7203 24.6669 20.1738 24.4041 19.7399L24.3985 19.2735L17.2009 12.0617C16.5463 11.4037 15.4795 11.4044 14.8228 12.0611L12.3889 14.5007C11.7328 15.1602 11.7318 16.2264 12.3892 16.8838L20.5752 25.0841C20.6288 25.1378 20.7015 25.168 20.7773 25.168C20.8532 25.168 20.9259 25.1378 20.9795 25.0841L24.4014 21.6565Z"
            fill={active ? color : '#C6C6C6'}
          />
          <path
            d="M37.9672 24.2508L31.1635 19.4094L21.7119 23.8252L28.4043 14.1137L37.196 12.7627"
            stroke={active ? color : '#C6C6C6'}
            strokeWidth="3.42758"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default AleaFeature04Icon;
